import Component from './Component';

export default class PopOutBanner extends Component {
  load() {
    this.initPopOutBanner();

    super.load();
  }

  initPopOutBanner() {
    const popOutToggle = document.getElementsByClassName('pop-out-banner__toggle');
    const popOutDismiss = document.getElementsByClassName('pop-out-banner__dismiss-btn');
    const popOutBanner = document.getElementsByClassName('pop-out-banner');
    if (!popOutBanner || !popOutToggle || !popOutDismiss) return;

    // Toggle pop out banner depending on cookie
    const cookie = this.getCookie('popOutBanner');
    if (!cookie || cookie === 'true') {
      console.log('Pop out banner is visible');
      popOutBanner[0].classList.add('banner-open');
    } else {
      console.log('Pop out banner is not visible');
      popOutBanner[0].classList.remove('banner-open');
    }

    // Toggle pop out banner
    popOutToggle[0].addEventListener('click', () => {
      this.setUnsetCookieOnClass(popOutBanner[0].classList.contains('banner-open'));

      popOutBanner[0].classList.toggle('banner-open');
    });
    popOutDismiss[0].addEventListener('click', () => {
      this.setUnsetCookieOnClass(popOutBanner[0].classList.contains('banner-open'));

      popOutBanner[0].classList.toggle('banner-open');
    });
  }

  setUnsetCookieOnClass(condition) {
    // Set pop up banner cookie depending on banner state
    if (condition) {
      this.setCookie('popOutBanner', 'false', 90);
    } else {
      this.setCookie('popOutBanner', 'true', 90);
    }
  }

  setCookie(name, value, days) {
    const expires = new Date();
    expires.setDate(expires.getDate() + days);
    document.cookie = name + '=' + value + ';expires=' + expires.toUTCString();
  }

  getCookie(name) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
}
